export const firebaseConfig = {
    apiKey: "AIzaSyCN8dRlw00ArBGJK693GRPgR0gjGMevtvc",
    authDomain: "crai-vm.firebaseapp.com",
    projectId: "crai-vm",
    storageBucket: "crai-vm.appspot.com",
    messagingSenderId: "790789908206",
    appId: "1:790789908206:web:e87de3712dac7ee81b75ff"
};
